import { DeliveryType, OrderStatus } from 'orderme-api-integration-client';
import i18next from '../i18n/i18n';

export enum OrderStatusSteps {
  None = 'none',
  Created = 'created',
  Accepted = 'accepted',
  Processing = 'processing',
  PickedUpByCourier = 'pickedUpByCourier',
  Ready = 'ready',
  Completed = 'completed',
}

export const getOrderStatusStep = (status: OrderStatus, isOnlyPhysicalItems: boolean, deliveryType: DeliveryType) => {
  switch (status) {
    case OrderStatus.ProcessingPayment:
    case OrderStatus.WaitingForPayment:
      return OrderStatusSteps.None;
    case OrderStatus.Cancelled:
    case OrderStatus.Processing:
      return OrderStatusSteps.Created;
    case OrderStatus.AcceptedBySalesPoint:
      return isOnlyPhysicalItems ? OrderStatusSteps.Processing : OrderStatusSteps.Accepted;
    case OrderStatus.Accepted:
    case OrderStatus.ReadyToPickUpByCourier:
      return OrderStatusSteps.Processing;
    case OrderStatus.PickedUpByCourier:
      // Services delivered to a sales point or locker have no courier step, so they stay at "processing"
      // until the order is ready for pick-up.
      return isOnlyPhysicalItems || deliveryType === DeliveryType.Address
        ? OrderStatusSteps.PickedUpByCourier
        : OrderStatusSteps.Processing;
    case OrderStatus.Ready:
      return OrderStatusSteps.Ready;
    case OrderStatus.Completed:
      return OrderStatusSteps.Completed;
    default:
      return OrderStatusSteps.None;
  }
};

export const getOrderStatusLabel = (status: OrderStatus, isOnlyPhysicalItems: boolean, deliveryType: DeliveryType) => {
  switch (status) {
    case OrderStatus.Cancelled:
      return i18next.t('orderStatus:cancelled');
    case OrderStatus.ProcessingPayment:
      return i18next.t('orderStatus:processingPayment');
    case OrderStatus.WaitingForPayment:
      return i18next.t('orderStatus:waitingForPayment');
    default:
      return getStepLabel(getOrderStatusStep(status, isOnlyPhysicalItems, deliveryType), isOnlyPhysicalItems);
  }
};

export const getStepLabel = (step: OrderStatusSteps, isOnlyPhysicalItems: boolean): string => {
  switch (step) {
    case OrderStatusSteps.Created:
      return i18next.t('orderStatus:processing');
    case OrderStatusSteps.Accepted:
      return i18next.t('orderStatus:acceptedBySalesPoint');
    case OrderStatusSteps.Processing:
      return isOnlyPhysicalItems ? i18next.t('orderStatus:beingPrepared') : i18next.t('orderStatus:accepted');
    case OrderStatusSteps.PickedUpByCourier:
      return i18next.t('orderStatus:pickedUpByCourier');
    case OrderStatusSteps.Ready:
      return i18next.t('orderStatus:ready');
    case OrderStatusSteps.Completed:
      return i18next.t('orderStatus:completed');
    default:
      return '';
  }
};

export const getStatusColor = (status: OrderStatus, isOnlyPhysicalItems: boolean) => {
  switch (status) {
    case OrderStatus.WaitingForPayment:
    case OrderStatus.Cancelled:
      return '#de0403';
    case OrderStatus.ProcessingPayment:
    case OrderStatus.Processing:
    case OrderStatus.AcceptedBySalesPoint:
    case OrderStatus.Accepted:
    case OrderStatus.ReadyToPickUpByCourier:
      return '#a4a4a4';
    case OrderStatus.PickedUpByCourier:
    case OrderStatus.Ready:
      return isOnlyPhysicalItems ? '#0195d6' : '#a4a4a4';
    case OrderStatus.Completed:
      return '#0195d6';
  }
};
